var exports = {
  "Qs": "xdde3148b--f6e3e5--content",
  "pq": "xdde3148b--f6e3e5--info",
  "QN": "xdde3148b--f6e3e5--company",
  "nf": "xdde3148b--f6e3e5--link",
};

module.exports = exports;
